// extracted by mini-css-extract-plugin
module.exports = {"LoadingTable":"LoadingTable_LoadingTable__2aZm6","loading":"LoadingTable_loading__EpLvI"};